import React, {Component} from 'react'

import './Copyright.styl'

class Copyright extends Component {
  render() {
    const year = new Date().getFullYear()

    return <span className="display-block text-center fs-14 p-10 text-color-secondary copyright">&copy;{year} 锐锢商城产品技术部</span>
  }
}

export default Copyright
